import { render, staticRenderFns } from "./ContainerItemDx.vue?vue&type=template&id=92bfb61e"
import script from "./ContainerItemDx.vue?vue&type=script&lang=js"
export * from "./ContainerItemDx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports